import React from 'react';
import EmergencySpokePage from './EmergencySpokePage';

// Spoke: Zahnabszess/dicke Backe — rote Warnbox mit 112/061-Hinweis.
const EmergencyAbscessPage: React.FC = () => (
  <EmergencySpokePage
    routeKey="emergency-abscess"
    namespace="abscess"
    warnboxVariant="danger"
    medicalCondition="Dental abscess"
  />
);

export default EmergencyAbscessPage;
